import { getTrans } from '@/utils/instantLoaded/tools';

export function formatTransVariable(content: string, variables = '') {
  let variablesObj = {} as Record<string, string | number>;
  try {
    variablesObj = JSON.parse(variables);
  } catch (error) {
    // do noting
  }
  const translateText = content.replace(/\$t{(.*?)}/g, (match, key) => (getTrans(key.trim()) || key));
  return translateText.replace(/{(.*?)}/g, (match, key) => variablesObj?.[key.trim()] === 0 ? '0' : variablesObj?.[key.trim()] || key);
}
